export default "__VITE_ASSET__RT1oYWHc__"